<template>
    <div class="data-center-wrap">
      <div class="container">
        <!-- 顶部快捷操作栏 -->
        <div class="quick-bar">
          <div class="bar-title">数据中心</div>
        </div>
  
        <!-- 当日汇总指标卡片 -->
        <div class="summary-card">
          <div class="summary-item">
            <div class="label">今日总调用次数</div>
            <div class="value">{{ overviewData.totalOrder }}</div>
          </div>
          <div class="summary-item">
            <div class="label">成功调用</div>
            <div class="value success">{{ overviewData.successOrder }}</div>
          </div>
          <div class="summary-item">
            <div class="label">失败调用</div>
            <div class="value danger">{{ overviewData.failOrder }}</div>
          </div>
          <div class="summary-item">
            <div class="label">接口成功率</div>
            <div class="value warn">{{ overviewData.successRate }}%</div>
          </div>
          <div class="summary-item">
            <div class="label">周调用量(本)</div>
            <div class="value">{{ overviewData.Week }} 次</div>
          </div>
          <div class="summary-item">
            <div class="label">月调用量(本)</div>
            <div class="value">{{ overviewData.Month }} 条</div>
          </div>
          <div class="summary-item">
            <div class="label">季调用量(本)</div>
            <div class="value">{{ overviewData.Quarter }} 次</div>
          </div>
          <div class="summary-item">
            <div class="label">年调用量(本)</div>
            <div class="value consume">{{ overviewData.Year }} 次</div>
          </div>
        </div>
  
        <!-- 查询筛选区域 -->
        <div class="filter-card">
          <el-form :model="query" inline>
            <el-form-item label="子账号">
              <el-select
                v-model="query.subAccountId"
                clearable
                placeholder="全部子账号"
                style="width: 180px"
              >
                <el-option
                  v-for="item in subAccountList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="调用状态">
              <el-select
                v-model="query.status"
                clearable
                placeholder="全部状态"
                style="width:160px"
              >
                <el-option label="查询中" value="1" />
                <el-option label="查询成功" value="2" />
                <el-option label="查询失败" value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="日期范围">
              <el-date-picker
                v-model="query.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadTableData">查询</el-button>
              <el-button @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 每日调用明细表格 -->
        <div class="info-card">
            <div class="card-head">
              <div class="card-title">每日调用明细记录</div>
            </div>
            <el-table :data="orderList" border stripe>
              <el-table-column label="日期" prop="create_time" align="center" width="200" />
              <el-table-column label="子账号名称" prop="user" align="center" min-width="110" />
              <el-table-column label="订单号" prop="orderno" align="center" min-width="160" />
              <el-table-column label="调用结果" align="center" width="100">
                <template #default="scope">
                  <el-tag
                    :type="scope.row.status === 2 ? 'success' : scope.row.status === 1 ? 'warning' : 'danger'"
                  >
                    {{ scope.row.status === 1 ? "查询中" : scope.row.status === 2 ? "查询成功" : "查询失败" }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="授权人" prop="name" align="center" width="100" />
              <el-table-column label="授权证件" prop="cardid" align="center" width="180" />
            </el-table>
            <!-- 分页 -->
            <div class="page-bar">
              <el-pagination
                v-model:current-page="page.pageNum"
                v-model:page-size="page.pageSize"
                :total="page.total"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="loadTableData"
                @current-change="loadTableData"
              />
            </div>
          </div>
        <!-- 主体左右布局 -->
        <div class="content-row">
          <!-- 左侧：子账号调用排行表格 -->
          <div class="left-column">
            <div class="info-card">
              <div class="card-head">
                <div class="card-title">子账号调用排行（当日）</div>
              </div>
              <el-table
                :data="rankList"
                border
                stripe
                ref="tableRef"
                height="380"
              >
                <el-table-column label="排名" type="index" align="center" width="70" />
                <el-table-column label="机构ID" prop="sub_id" align="center" min-width="120" />
                <el-table-column label="登录账号" prop="sub_name" align="center" min-width="130" />
                <el-table-column label="调用总次数" prop="today_order_count" align="center" width="110" />
                
                <el-table-column label="操作" align="center" width="100">
                  <template #default="scope">
                    <el-button text type="primary" @click="openDetail(scope.row)">明细</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
  
          <!-- 右侧图表区域 -->
          <div class="right-column">
            <!-- 今日调用趋势 -->
            <div class="info-card chart-card">
              <div class="card-head">
                <div class="card-title">今日调用趋势</div>
              </div>
              <div class="chart-box" ref="chartRef"></div>
            </div>
            <!-- 失败原因分布 -->
            <div class="info-card">
              <div class="card-head">
                <div class="card-title">失败类型统计</div>
              </div>
              <div class="error-row" v-for="item in errorStatList" :key="item.type">
                <div class="error-label">{{ item.typeName }}</div>
                <div class="error-count">{{ item.count }} 次</div>
              </div>
            </div>
          </div>
        </div>
  
        
      </div>
  
      <!-- 子账号当日明细弹窗【独立分页】 -->
      <el-dialog v-model="detailDialogVisible" title="子账号调用明细" width="760px" @close="onDialogClose">
        <el-table :data="currentDetailList" border stripe max-height="420">
          <el-table-column label="调用时间" prop="create_time" align="center" width="180" />
          <el-table-column label="订单号" prop="orderno" align="center" min-width="160" />
          <el-table-column label="调用结果" align="center" width="100">
            <template #default="scope">
              <el-tag
                :type="scope.row.status === 2 ? 'success' : scope.row.status === 1 ? 'warning' : 'danger'"
              >
                {{ scope.row.status === 1 ? "查询中" : scope.row.status === 2 ? "查询成功" : "查询失败" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="授权人" prop="name" align="center" width="110" />
          <el-table-column label="授权证件" prop="cardid" align="center" width="170" />
        </el-table>
        <div class="page-bar" style="margin-top:12px;">
          <el-pagination
            v-model:current-page="pageDetail.pageNum"
            v-model:page-size="pageDetail.pageSize"
            :total="pageDetail.total"
            layout="total, prev, pager, next"
            @current-change="loadSubDetail"
          />
        </div>
        <template #footer>
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, onMounted, onUnmounted, nextTick } from "vue";
  import { ElMessage } from "element-plus";
  import * as echarts from "echarts";
  // 新增导入 getUserSubList
  import { getJpOrderList, getPhbList, getUserSubList, getOverview } from "@/api/api";
  
  // ========== 主列表分页 ==========
  const page = reactive({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });
  const orderList = ref([]);
  
  // ========== 弹窗明细独立分页 ==========
  const pageDetail = reactive({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });
  let currentSubId = null; //保存当前选中子账号ID
  const currentDetailList = ref([]);
  
  // 排行榜数据
  const rankList = ref([]);
  
  const tableRef = ref(null);
  const chartRef = ref(null);
  let chartInstance = null;
  
  // 查询条件 新增status
  const query = reactive({
    subAccountId: "",
    dateRange: [],
    status: "",
  });
  
  // 顶部汇总指标
  const overview = reactive({
    totalCall: 0,
    successCall: 0,
    failCall: 0,
    successRate: "0.00",
    dayLimit: 0,
    pendingNum: 0,
    yearTotal: 0,
    yearUsed: 0,
  });
  
  // 下拉选项
  const subAccountList = ref([]);
  //失败统计（预留）
  const errorStatList = ref([]);
  
  //弹窗控制
  const detailDialogVisible = ref(false);




  /**
   * 获取子账号下拉列表
   */
  const getSubListOption = async () => {
    const res = await getUserSubList(

    {
        iam_static: "",
        pageNum: 1,
        pageSize: 100,
    }
    );
    if(res.code === 200) {
      subAccountList.value = res.data.list;
    }
  };
  
  /**
   * 主表格：每日调用明细
   */
  const getOrderList = async () => {
    const params = {
      page: page.pageNum,
      pageSize: page.pageSize,
      status: query.status || "",
      sub_id: query.subAccountId || "",
    };
    const res = await getJpOrderList(params);
    if (res.code === 200) {
      orderList.value = res.data.list;
      page.total = res.data.total;
      // 拿到列表数据，组装图表
      buildChartData(res.data.list);
    }
  };

  /**
   * 根据列表create_time 按小时聚合数据，生成图表数据源
   * create_time格式示例 "2026-07-28T22:43:10"
   */
  const buildChartData = (list) => {
    // 初始化0~23点，初始0次
    const hourMap = {};
    for(let i = 0; i <= 23; i++){
      hourMap[i] = 0;
    }

    list.forEach(item => {
      if(!item.create_time) return;
      const timeStr = item.create_time;
      //分割T，取出小时
      const hourPart = timeStr.split("T")[1];
      const hour = parseInt(hourPart.split(":")[0]);
      hourMap[hour]++;
    })

    // 组装x轴标签、数值数组
    const xAxisData = Object.keys(hourMap).map(h => `${h}点`);
    const seriesData = Object.values(hourMap);
    renderChart(xAxisData, seriesData);
  }

  /**
   * 渲染ECharts
   */
  const renderChart = (xData, sData) => {
    if(!chartInstance) return;
    const option = {
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true
      },
      xAxis: {
        type: "category",
        data: xData
      },
      yAxis: {
        type: "value",
        min: 0
      },
      series: [
        {
          name: "调用次数",
          type: "line",
          smooth: true,
          data: sData,
          itemStyle: { color: "#2b5bff" },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(43,91,255,0.3)" },
                { offset: 1, color: "rgba(43,91,255,0.03)" }
              ]
            }
          }
        }
      ]
    };
    chartInstance.setOption(option);
  };
  
  /**
   * 获取子账号排行榜
   */
  const getSubPhbList = async () => {
    const res = await getPhbList();
    if (res.code === 200) {
      rankList.value = res.data.list;
    }
  };


  const overviewData = ref({});

  /**
   * 获取顶部汇总指标
   */
  const getOverviewFunction = async () => {
    const res = await getOverview();
    if(res.code == 200) {
        overviewData.value = res.data;
    }
  };



  
  /**
   * 打开弹窗，加载单个子账号明细
   */
  const openDetail = async (row) => {
    currentSubId = row.sub_id;
    pageDetail.pageNum = 1;
    detailDialogVisible.value = true;
    await loadSubDetail();
  };
  
  /**
   * 加载子账号明细（弹窗内表格）
   */
  const loadSubDetail = async () => {
    const params = {
      page: pageDetail.pageNum,
      pageSize: pageDetail.pageSize,
      status: "",
      sub_id: currentSubId,
    };
    const res = await getJpOrderList(params);
    if (res.code === 200) {
      currentDetailList.value = res.data.list;
      pageDetail.total = res.data.total;
    }
  };






  
  /**
   * 弹窗关闭清空缓存
   */
  const onDialogClose = () => {
    currentSubId = null;
    currentDetailList.value = [];
    pageDetail.total = 0;
  };
  
  /**
   * 重置筛选
   */
  const resetQuery = () => {
    query.subAccountId = "";
    query.dateRange = [];
    query.status = "";
    loadTableData();
  };
  
  /**
   * 查询入口：同时刷新主表+排行榜
   */
  const loadTableData = async () => {
    page.pageNum = 1;
    await Promise.all([getOrderList(), getSubPhbList()]);
  };
  
  /**
   * 初始化图表
   */
  const initChart = async () => {
    await nextTick();
    if (!chartRef.value) return;
    if (chartInstance) {
      chartInstance.dispose();
      chartInstance = null;
    }
    chartInstance = echarts.init(chartRef.value);
    // 初始空图表，等待接口回填数据
    renderChart([], []);
  };
  
  //窗口自适应
  const resizeChart = () => {
    if (!chartInstance || !chartRef.value) return;
    chartInstance.resize();
  };
  
  onMounted(async () => {
    // 先加载子账号下拉选项
    await getSubListOption();
    await initChart();
    // 加载顶部汇总指标
    await getOverviewFunction();
    await loadTableData();
    window.addEventListener("resize", resizeChart);
  });
  
  onUnmounted(() => {
    window.removeEventListener("resize", resizeChart);
    if (chartInstance) {
      chartInstance.dispose();
      chartInstance = null;
    }
  });
  </script>
  
  <style lang="scss" scoped>
  .data-center-wrap {
    width: 100%;
    min-height: 100vh;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
    background: radial-gradient(1200px 600px at 10% -10%, #e8efff 0%, transparent 60%),
      radial-gradient(900px 500px at 110% 110%, #f0eaff 0%, transparent 55%),
      linear-gradient(180deg, #f7f9ff 0%, #eef2fb 100%);
  
    .container {
      max-width: 1400px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  
    .quick-bar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      border-radius: 16px;
      padding: 18px 24px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
      .bar-title {
        font-size: 20px;
        font-weight: 600;
        color: #111827;
      }
    }
  
    .summary-card {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
      background: #fff;
      border-radius: 16px;
      padding: 20px 24px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
      .summary-item {
        text-align: center;
        .label {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 8px;
        }
        .value {
          font-size: 26px;
          font-weight: 600;
          color: #111827;
          &.success {
            color: #00b42a;
          }
          &.danger {
            color: #f53f3f;
          }
          &.warn {
            color: #ff7d00;
          }
          &.consume {
            color: #de1c2c;
          }
        }
      }
    }
  
    .filter-card {
      background: #ffffff;
      border-radius: 16px;
      padding: 16px 20px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
    }
  
    .content-row {
      display: grid;
      grid-template-columns: 1fr 360px;
      gap: 20px;
    }
    .left-column,
    .right-column {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  
    .info-card {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px;
      box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 12px 32px -12px rgba(16, 24, 40, 0.12),
        0 32px 64px -32px rgba(43, 91, 255, 0.18);
      .card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 16px;
        border-bottom: 1px solid #eef0f5;
        margin-bottom: 16px;
        .card-title {
          font-size: 16px;
          font-weight: 600;
          color: #111827;
        }
      }
    }
  
    .chart-box {
      width: 100%;
      height: 260px;
    }
  
    .error-row {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #f3f4f6;
      &:last-child {
        border-bottom: none;
      }
      .error-label {
        color: #6b7280;
      }
      .error-count {
        color: #1f2937;
        font-weight: 500;
      }
    }
  
    .page-bar {
      width: 100%;
      padding-top: 16px;
      display: flex;
      justify-content: flex-end;
    }
  }
  
  @media (max-width: 1200px) {
    .content-row {
      grid-template-columns: 1fr;
    }
    .summary-card {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 720px) {
    .data-center-wrap {
      padding: 12px;
    }
    .quick-bar {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
  }
  </style>